import EventBus from "./event-bus";
import {errorHandler} from "./utils";

const axios = require('axios');

export function placeOrder(order) {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    axios.post(process.env.ROOT_API + 'merchant/order',  JSON.stringify(order), {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}

export function checkCanSubmitOrder() {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    axios.get(process.env.ROOT_API + 'merchant/canOrder', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function getNextDeliveryDateFromServer() {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    axios.get(process.env.ROOT_API + 'merchant/deliveryDate', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function getOrderList(query) {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    axios.get(process.env.ROOT_API + 'merchant/orders?' + query, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}

export function getVendorOrderList(query) {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    axios.get(process.env.ROOT_API + 'merchant/vendor/orders?' + query, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}

export function sendDeliveryNote(orderId) {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    axios.get(process.env.ROOT_API + 'merchant/order/deliveryNote/email?orderId=' + orderId, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}

export function getAdminMerchants() {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/merchants', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}

export function newChildOrderFromOrder(order, memo = '') {


  let item = {
    id:0,
    productId: order.productId,

    merchantPrice: order.merchantPrice,
    price: order.price,
    orderedAmount: order.amount,
    amount: order.amount,

    title: order.title,
    originalPrice: order.originalPrice,
    marginRate: order.marginRate,
    marginAmount: order.marginAmount,
    totalPrice: order.price * order.amount,
    taxRate:order.taxRate,
    tax: order.price * order.amount * order.taxRate / 10000,

    description: order.description,

    imageUrls: order.imageUrls,
    note:memo,

    useVariablePrice: order.useVariablePrice,
    variablePriceUnit: order.variablePriceUnit,
  };

  item.finalDue = item.totalPrice + item.tax;

  return item;
}
export function newChildOrder(product, memo = '') {
  let imageUrls = []
  if(product.imageUrls.length > 0){
    imageUrls.push(product.imageUrls[0])
  }

  let item = {
    id:0,
    productId: product.id,

    merchantPrice: product.price,
    price: product.price,
    orderedAmount: product.amount,
    amount: product.amount,

    title: product.title,
    originalPrice: product.sourcePrice,
    marginRate: product.marginRate,
    marginAmount: product.marginAmount,
    totalPrice: product.price * product.amount,
    taxRate:product.taxRate,
    tax: product.price * product.amount * product.taxRate / 10000,

    description: product.description,

    imageUrls: imageUrls,
    note:memo,

    useVariablePrice: product.useVariablePrice,
    variablePriceUnit: product.variablePriceUnit,

    categoryId: product.categoryId,
    categoryTitle: '',
  };

  item.finalDue = item.totalPrice + item.tax;

  return item;
}

export function newParentOrder(vendorId = 0) {
  return {
    id:0,
    state: 0,
    totalPrice:0,
    taxRate:0,
    tax:0,
    finalDue:0,
    list: [],
    note:'',
    deliveryDate:'',
    vendorId:vendorId,
  }
}

function getBasketName(vendorId) {
  return `BASKET_${vendorId}`
}

export function saveBasket(cartOrder, vendorId = 0) {
  let basketName = getBasketName(vendorId)

  localStorage.setItem(basketName, JSON.stringify(cartOrder))
}
export function clearBasket(vendorId = 0) {
  let basketName = getBasketName(vendorId)

  localStorage.removeItem(basketName);
}
export function loadBasket(vendorId = 0) {
  let basketName = getBasketName(vendorId)
  let cartOrderJson = localStorage.getItem(basketName)

  if(cartOrderJson === null || cartOrderJson === undefined){
    return newParentOrder(vendorId)
  } else {
    return JSON.parse(cartOrderJson)
  }
}

export function loadBaskets() {
  let baskets = []
  for(let i=0; i<localStorage.length; i++) {
    let key = localStorage.key(i)
    if (key.includes('BASKET_')){
      let item = localStorage.getItem(key)

      baskets.push(JSON.parse(item))
    }
  }

  return baskets
}

export function getBasketOrderCount() {
  let num = 0
  for(let i=0; i<localStorage.length; i++) {
    let key = localStorage.key(i)
    if (key.includes('BASKET_')){
      let item = localStorage.getItem(key)
      let basket = JSON.parse(item)
      // console.log(basket)

      if(basket.list != undefined && basket.list != null && basket.list.length > 0) {
        for(let j = 0 ; j < basket.list.length ; j++) {
          num += parseInt(basket.list[j].amount);
        }
      }

    }
  }

  return num
}

export function getDeliveryDay (deliveryDates) {

  let today = new Date();
  let dayOfTheWeek = (today.getDay() + 6) % 7
  // 오늘을 포함한 일주일 탐색
  for(let i=0; i<7; i++){
    // 오늘부터 일주일간의 요일 인덱스
    let index = (dayOfTheWeek + i) % 7

    // 배송 가능한 날짜 탐색
    if(deliveryDates[index] !== undefined) {
      let isNextWeek = (dayOfTheWeek + i >= 7)
      // 주문 가능 기한 날짜 확인
      if (isNextWeek || dayOfTheWeek <= deliveryDates[index].cutOffDay) {
        // 오늘 일자를 기준으로 일수 증가
        let deliveryDate = new Date()
        deliveryDate.setDate(today.getDate() + i)

        // 문자열 변환
        return deliveryDate.toISOString().split('T')[0]
      }
    }
  }
  return '0000-00-00';
}



// WEBPACK FOOTER //
// ./src/api/order.js